/*
 Code for the disruptive technologies sensors, currently unused. Originally from NavVis example and modified.
 */

var AUTH_TOKEN = null
var SENSOR_URL = 'https://api.disruptive-technologies.com/v2/'

// depending on IV version this moved, so find any jQuery
export function updatePOI(sensor, ivApi) {
  // This is explicitely an internal API and can break in future versions!
  var repository = ivApi.legacyApi.getPoiRepository()
  // extract ID of sensor from URL
  var sensorId = extractIdFromName(sensor.name)

  var dirty = false
  // need to filter our POIs to find all matches based on custom_data
  for (var poi of repository.data) {
    // find a POI where it matches
    if (poi.customData !== sensorId) {
      continue
    }

    var data = sensor.reported
    // id match found, now update title based on resourceType
    switch (sensor.type) {
      case 'temperature':
        changeTitle(poi, data.temperature.value + ' °C')
        dirty = true
        break
      case 'touch':
        changeTitle(
          poi,
          'Senast klickad den ' + new Date(Date.parse(data.touch.updateTime)).toUTCString()
        )
        dirty = true
        break
      case 'proximity':
        if (poi.poiType.name.en === 'Entrance/Exit') {
          changeTitle(
            poi,
            'Dörren är ' + (data.objectPresent.state === 'PRESENT' ? 'stängd' : 'öppen')
          )
        } else {
          changeTitle(
            poi,
            'Object is ' + (data.objectPresent.state === 'PRESENT' ? 'present' : 'absent')
          )
        }
        dirty = true
        break
      default:
        // these need to be implemented as above, we can't handle unknown types
        console.warn('Unhandled type:', sensor.type)
    }
  }
  // return whether we touched any so we can update POI rendering
  return dirty
}
export function login(ivApi) {
  var $ = ivApi.lib.jQuery || ivApi.lib.angular.element
  // create JWT
  var header = JSON.stringify({
    alg: 'HS256',
    kid: process.env.VUE_APP_DISRUPTIVE_SERVICE_ACCOUNT_KEY
  })
  var payload = JSON.stringify({
    iat: KJUR.jws.IntDate.get('now'),
    exp: KJUR.jws.IntDate.get('now + 1hour'),
    aud: 'https://identity.disruptive-technologies.com/oauth2/token',
    iss: process.env.VUE_APP_DISRUPTIVE_SERVICE_ACCOUNT_EMAIL
  })

  var jwt = KJUR.jws.JWS.sign('HS256', header, payload, {
    utf8: process.env.VUE_APP_DISRUPTIVE_SERVICE_ACCOUNT_SECRET
  })

  var request = {
    assertion: jwt,
    grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer'
  }

  $.post('https://identity.disruptive-technologies.com/oauth2/token', request, function (response) {
    var init = !AUTH_TOKEN
    AUTH_TOKEN = response.access_token
    // token only valid for 1 hour, so refetch new one before it expires
    setTimeout(login, 59 * 60 * 1000, ivApi)
    // only start query the first time – later it'll just silently update the AUTH_TOKEN and query will keep working
    if (init) query(true, ivApi)
  })
}
// poll the sensors every second and update POIs
function query(first, ivApi) {
  var $ = ivApi.lib.jQuery || ivApi.lib.angular.element
  $.get(
    SENSOR_URL +
      'projects/' +
      process.env.VUE_APP_DISRUPTIVE_PROJECT_ID +
      '/devices' +
      '?token=' +
      AUTH_TOKEN,
    function (data) {
      var devices = data.devices
      if (data.nextPageToken) {
        $.get(
          SENSOR_URL +
            'projects/' +
            process.env.VUE_APP_DISRUPTIVE_PROJECT_ID +
            '/devices' +
            '?token=' +
            AUTH_TOKEN +
            '&page_token=' +
            data.nextPageToken,
          function (data2) {
            let allDevices = devices.concat(data2.devices)
            handleSubscribeData(allDevices, ivApi)
          }
        )
        // If you DO have more, you need to fetch them and add them to the devices array before going on
      }

      // query again in a second
      setTimeout(query, 1000, false, ivApi)
    }
  )
}

// handles receiving subscribed to data updates, updates POIs accordingly
function handleSubscribeData(sensors, ivApi) {
  var dirty = false
  for (var sensor of sensors) {
    dirty |= updatePOI(sensor, ivApi)
  }
  // update only if a POI was dirtied
  if (dirty) {
    // This is explicitely an internal API and can break in future versions!
    ivApi.poi.service.refreshPois()
  }
}

// change the title of the given POI, also appends date of last update (so NOW)
// This is explicitely an internal API and can break in future versions!
export function changeTitle(poi, title, time) {
  // change Poi's english translation
  if (time) {
    time = new Date(Date.parse(time))
    title += ' [' + time.toUTCString() + ']'
  }
  poi.titles = { en: title }
}
function extractIdFromName(name) {
  return name.split('/').pop()
}
